import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { SiteHeader } from '@/components/site/site-header'
import { SiteFooter } from '@/components/site/site-footer'
import { WhatsAppButton } from '@/components/site/whatsapp-button'

// Public site chrome: announcement bar, header, footer and the floating WhatsApp button.
export const Layout: FC<LayoutProps> = ({ children, data, hideFloatingChat = false }): ReactNode => {
    return (
        <div className='flex min-h-screen flex-col'>
            <a
                href='#main'
                className='sr-only z-50 rounded-full bg-navy-900 px-4 py-2 text-sm text-cream-50 focus:not-sr-only focus:fixed focus:top-3 focus:left-3'
            >
                Skip to content
            </a>

            <SiteHeader profile={data.profile} announcement={data.announcement} />

            <main id='main' className='flex-1'>
                {children}
            </main>

            <SiteFooter profile={data.profile} categories={data.categories} />
            {!hideFloatingChat && <WhatsAppButton profile={data.profile} />}
        </div>
    )
}
